import { Component, OnInit, NgZone, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ControlPosition, MapTypeControlOptions, MapsAPILoader, MouseEvent } from '@agm/core';
import { Observable } from 'rxjs';
import { sweetAlert } from '../../../utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { loadStaticMap } from '../../../utils/utils.common';
import { DispatchCenterService } from '../../../service/dispatch-center-service/dispatch-center-service';
import { LatLngLiteral } from '@agm/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { LevelOfServiceService } from '../../../service/level-of-service/level-of-service.service';
import { AssigTripsService } from 'src/app/service/assigntrips-service/assigntrips-service';
import { CorporateService } from 'src/app/service/corporate-service/corporate-service';
import { environment } from 'src/environments/environment';
import { Settings } from '../../user profile/edit-user-profile/edit-user-profile.component';
import { AuthService } from 'src/app/service/auth-service/auth.service';

@Component({
  selector: 'app-trip-details',
  templateUrl: './trip-details.component.html',
  styleUrls: ['./trip-details.component.css']
})
export class TripDetailsComponent implements OnInit, OnDestroy {
  @Input() tripId: any
  @Input() openFrom?: any
  @Output() onCloseModal = new EventEmitter<any>();
  address: string;
  zoom: number;
  jobId;

  tripDetails = null;
  jobAcceptedUrl = null;
  jobOnSceneUrl = null;
  jobStartedUrl = null;
  jobEndedUrl = null;
  jobFinishedUrl = null;
  jobCancelledUrl = null;
  mapTypeControlOptions: MapTypeControlOptions = {
    position: ControlPosition.TOP_LEFT
  };
  isDrawRoute = false;
  origin = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  assign;
  cameraImages;
  user;
  tripAssistance: {
    displayName: '',
    contactNumber: ''
  };
  contact;
  trackinURL;
  dateFormat = '';
  timeFormat = '';
  constructor(
    private authService: AuthService,
    private levelOfServiceService : LevelOfServiceService,
    private corporateService: CorporateService,
    private dispatchCenterService: DispatchCenterService,
    private assigTripsService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private assignTripService : AssigTripsService
  ) { }

  ngOnInit() {
    this.getFormats();
    this.trackinURL = environment.TRACKING_URL;
    this.jobId = this.tripId;
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.getCompletedTripDetail();
        }
      });
  }

  getFormats() {
    const dateFormat = localStorage.getItem(Settings.DATE_FORMAT);
    const timeFormat = localStorage.getItem(Settings.TIME_FORMAT);
    this.dateFormat = dateFormat ? dateFormat : Settings.DEFAULT_DATE_FORMAT;
    this.timeFormat = timeFormat ? timeFormat : Settings.DEFAULT_TIME_FORMAT
  }

  twodigit(val) {
    return parseFloat(Number(Math.round(parseFloat(val)) + 'e-0').toFixed(2));
  }

  closeDetailModal() {
    this.onCloseModal.emit();
  }

  breakString(str) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }

  isStringExist(substrings, str) {
    if (substrings.some(v => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  sendSMS() {
    if (!this.tripAssistance.displayName || !this.tripAssistance.contactNumber) return;
    this.assigTripsService
      .sendTripAssistanceSMS(this.tripDetails._id, this.tripAssistance)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (data.success) {
            sweetAlert('Success', data.message + ' ' + data.link, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }

  sendTrackingSMS() {
    if (!this.contact) return;
    this.tripDetails.contactNumber = this.contact;

    const payload = {
      ...this.tripDetails,
      tripId: this.tripDetails._id,
      latitude: this.tripDetails.driver.latitude,
      longitude: this.tripDetails.driver.longitude,
    }
    this.assignTripService
      .sendTrackingSMS(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // this.contact = '';
          if (data.success) {
            sweetAlert('Success', data.message, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }

  async getCompletedTripDetail() {
    try {
      const data = await this.dispatchCenterService.getTripDetail(this.jobId).toPromise();
  
      if (data) {
        this.tripDetails = data;
  
        if (data.priorityClient) {
          this.contact = data.priorityClient.contactNumber;
        }
  
        this.tripAssistance = {
          displayName: this.tripDetails.priorityClient.displayName,
          contactNumber: this.tripDetails.priorityClient.contactNumber
        };
  
        if (this.tripDetails.job && this.tripDetails.job.trackInfoJob) {
          const trackInfo = this.tripDetails.job.trackInfoJob;
  
          if (trackInfo.jobAccepted) {
            this.jobAcceptedUrl = await this.loadStaticMap(trackInfo.jobAccepted.coords[1], trackInfo.jobAccepted.coords[0]);
          }
  
          if (trackInfo.jobArrived) {
            this.jobOnSceneUrl = await this.loadStaticMap(trackInfo.jobArrived.coords[1], trackInfo.jobArrived.coords[0]);
          }
  
          if (trackInfo.jobStarted) {
            this.jobStartedUrl = await this.loadStaticMap(trackInfo.jobStarted.coords[1], trackInfo.jobStarted.coords[0]);
          }
  
          if (trackInfo.jobCompleted) {
            this.jobEndedUrl = await this.loadStaticMap(trackInfo.jobCompleted.coords[1], trackInfo.jobCompleted.coords[0]);
          }
  
          if (trackInfo.jobFinished) {
            this.jobFinishedUrl = await this.loadStaticMap(trackInfo.jobFinished.coords[1], trackInfo.jobFinished.coords[0]);
          }
  
          if (trackInfo.jobCancelled) {
            this.jobCancelledUrl = await this.loadStaticMap(trackInfo.jobCancelled.coords[1], trackInfo.jobCancelled.coords[0]);
          }
        }
  
        this.origin = {
          lat: this.tripDetails.jobOriginLatitude,
          lng: this.tripDetails.jobOriginLongitude
        };
        this.destination = {
          lat: this.tripDetails.jobDestinationLatitude,
          lng: this.tripDetails.jobDestinationLongitude
        };
        this.getConfigurations();
      }
    } catch (error) {
      console.error('Error fetching trip details:', error);
    }
  }

  getConfigurations() {
    this.assignTripService
      .getConfigurations({status: 'active'})
      .subscribe(data => {
        if (data) {
          if(data.levelofservices && data.levelofservices.length){
            this.tripDetails.los = data.levelofservices.find((item) => item._id === this.tripDetails.los);
            this.tripDetails.los = this.tripDetails.los ? this.tripDetails.los.title : 'N/A';
          }
          if(data.spacetypes && data.spacetypes.length){
            this.tripDetails.spaceType = data.spacetypes.find((item) => item._id === this.tripDetails.spaceType);
            this.tripDetails.spaceType = this.tripDetails.spaceType ? this.tripDetails.spaceType.title : 'N/A';
          }
          
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  loadStaticMap = async (lat, lng) => {
    let mapKey = '';
    const res = await this.authService.getGoogleKeys().toPromise();
    if (res && res.key) {
      console.log('Load static map API key:');
      mapKey = res.key;
    } else {
      console.error('Error load static map API key');
    }
    let url = 'https://maps.googleapis.com/maps/api/staticmap?center='
      + lat + ',' + lng + '&zoom=18&size=500x500&maptype=satellite&markers=color:red|' + lat
      + ',' + lng + '&key=' + mapKey;

    return url;
  }

  ngOnDestroy(): void {
  }

}
